"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTransformer = actionTransformer;
exports.logger = void 0;

var _batch = _interopRequireDefault(require("../batch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var batchType = _batch["default"].getType();

function actionTransformer(action) {
  if (action && action.type === batchType) {
    action.payload.type = batchType;
    return action.payload;
  }

  return action;
}

var logger = {};
exports.logger = logger;

var _loop = function _loop(level) {
  if (typeof console[level] === 'function') {
    logger[level] = function levelFn() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var lastArg = args.pop();

      if (Array.isArray(lastArg) && lastArg.type === batchType) {
        lastArg.forEach(function (action) {
          console[level].apply(console, [].concat(args, [action]));
        });
      } else {
        args.push(lastArg);
        console[level].apply(console, args);
      }
    };
  }
};

for (var level in console) {
  _loop(level);
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-act/lib/loggers/reduxLogger.js
// module id = 2030
// module chunks = 0